// Enabled only by the staff demo build; this marker is not a credential.
export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';
export const DEMO_CONFIRMATION = 'ella-demo-confirm';
